import { useNavigate } from 'react-router-dom'

function AboutPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-[#fefcf8]">
      <div className="w-full md:w-[90%] lg:w-[80%] mx-auto px-4 py-8">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#001F3F] to-[#003366] rounded-2xl p-8 md:p-12 mb-8 text-white">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">À propos de KUDHI</h1>
          <p className="text-lg">Votre plateforme de mise en relation entre vendeurs et acheteurs, entreprises et particuliers en Côte d'Ivoire</p>
        </div>

        {/* Contenu principal */}
        <div className="bg-white rounded-xl shadow-sm p-6 md:p-8 mb-8">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#001F3F] mb-4">Notre Mission</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              KUDHI est né d'une vision simple mais ambitieuse : faciliter la mise en relation entre vendeurs et acheteurs, 
              entreprises et particuliers en Côte d'Ivoire grâce à une plateforme moderne, sécurisée et accessible à tous. 
              Nous croyons que chaque personne et chaque entreprise mérite un espace où échanger en toute confiance.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Notre mission est de connecter des millions d'Ivoiriens, de créer des opportunités économiques pour les 
              particuliers et les entreprises, et de contribuer au développement du commerce digital dans notre pays.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#001F3F] mb-4">Nos Valeurs</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="border border-gray-200 rounded-lg p-6">
                <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-[#001F3F] mb-2">Confiance</h3>
                <p className="text-gray-600">
                  Nous mettons tout en œuvre pour garantir des transactions sécurisées et transparentes entre nos utilisateurs.
                </p>
              </div>

              <div className="border border-gray-200 rounded-lg p-6">
                <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-[#001F3F] mb-2">Innovation</h3>
                <p className="text-gray-600">
                  Nous innovons constamment pour offrir une expérience utilisateur moderne et intuitive.
                </p>
              </div>

              <div className="border border-gray-200 rounded-lg p-6">
                <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-[#001F3F] mb-2">Communauté</h3>
                <p className="text-gray-600">
                  Nous construisons une communauté forte et solidaire d'acheteurs et de vendeurs.
                </p>
              </div>

              <div className="border border-gray-200 rounded-lg p-6">
                <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-[#001F3F] mb-2">Accessibilité</h3>
                <p className="text-gray-600">
                  Notre plateforme est gratuite et accessible à tous, partout en Guinée.
                </p>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#001F3F] mb-4">Notre Histoire</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Fondée en 2024 par Unloader Technologies à Grand Bassam, KUDHI est rapidement devenue la plateforme de référence 
              pour la mise en relation entre vendeurs et acheteurs, entreprises et particuliers en Côte d'Ivoire. Nous avons démarré 
              avec une simple idée : rendre les échanges commerciaux locaux plus accessibles et transparents.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Aujourd'hui, des milliers d'utilisateurs - particuliers et entreprises - nous font confiance chaque jour pour se connecter, 
              échanger et concrétiser leurs projets. De l'automobile à l'immobilier, en passant par l'électronique, la mode et les services B2B, 
              KUDHI facilite tous types de transactions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#001F3F] mb-4">Nos Chiffres</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="text-center p-6 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg">
                <div className="text-3xl md:text-4xl font-bold text-[#D4AF37] mb-2">10K+</div>
                <div className="text-sm text-gray-600">Utilisateurs actifs</div>
              </div>
              <div className="text-center p-6 bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg">
                <div className="text-3xl md:text-4xl font-bold text-[#D4AF37] mb-2">50K+</div>
                <div className="text-sm text-gray-600">Annonces publiées</div>
              </div>
              <div className="text-center p-6 bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg">
                <div className="text-3xl md:text-4xl font-bold text-[#D4AF37] mb-2">15</div>
                <div className="text-sm text-gray-600">Catégories</div>
              </div>
              <div className="text-center p-6 bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg">
                <div className="text-3xl md:text-4xl font-bold text-[#D4AF37] mb-2">24/7</div>
                <div className="text-sm text-gray-600">Support disponible</div>
              </div>
            </div>
          </section>
        </div>

        {/* Section Contact */}
        <div className="bg-gradient-to-r from-[#D4AF37] to-[#c09d2a] rounded-xl p-6 md:p-8 text-white text-center">
          <h2 className="text-2xl font-bold mb-4">Rejoignez-nous aujourd'hui !</h2>
          <p className="mb-6">Commencez à acheter et vendre en toute simplicité sur KUDHI</p>
          <button
            onClick={() => navigate('/ligdi')}
            className="px-8 py-3 bg-white text-[#D4AF37] font-semibold rounded-lg hover:bg-gray-100 transition-colors shadow-md"
          >
            Découvrir la plateforme
          </button>
        </div>
      </div>
    </div>
  )
}

export default AboutPage
